import { ExcelService } from './../../_services/excel.service';
import { AddToTalentpoolComponent } from './../../talentpool/add-to-talentpool/add-to-talentpool.component';
import { TalentpoolService } from './../../_services/talentpool.service';
import { CandidateService } from './../../_services/candidate.service';
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild, Inject, Input, HostListener, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateNoteComponent } from '../candidate-note/candidate-note.component';
import { CandidateEmailComponent } from '../candidate-email/candidate-email.component';
import { Observable, of, Subject } from 'rxjs';
import { CreateTalentpoolComponent } from 'src/app/talentpool/create-talentpool/create-talentpool.component';
import * as _ from 'underscore';
import * as __ from 'lodash';
import { GlobalService } from 'src/app/_services/global.service';
import { CallLogComponent } from '../call-log/call-log.component';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import moment from 'moment';
import { CandidateTagsComponent } from '../candidate-tags/candidate-tags.component';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { CampaignService } from 'src/app/_services/campaign.service';
import { campaignModel } from 'src/app/model/campaign';
import { UntypedFormControl, Validators } from '@angular/forms';

import { BulkRevealModalComponent } from 'src/app/bulk-reveal-modal/bulk-reveal-modal.component';

import { EmailsettingsService } from 'src/app/_services/emailsettings.service';

import { CreateCandidateComponent } from '../create-candidate/create-candidate.component'
import { CreateCandidateNewComponent } from '../create-candidate-new/create-candidate-new.component';
import { AtsResumeScreenService } from 'src/app/_services/ats-resume-screen.service';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { BulkResumeUploadModelComponent } from 'src/app/import-candidate/bulk-resume-upload-model/bulk-resume-upload-model.component';
import { CsvFileUploadModelComponent } from 'src/app/import-candidate/csv-file-upload-model/csv-file-upload-model.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AddCandidateAegisModalComponent } from 'src/app/person-search-listing/add-candidate-aegis-modal/add-candidate-aegis-modal.component';
import { AegisIntegrationService } from 'src/app/_services/aegisIntegration.service';
declare const clevertap;

@Component({
    selector: 'app-candidate-list',
    templateUrl: './candidate-list.component.html',
    styleUrls: ['./candidate-list.component.scss'],
    providers: [ExcelService],
    standalone: false
})
export class CandidateListComponent implements OnInit {

  talentpoolid: any;
  talentpoolview: boolean;
  candidatelist: any[] = [];
  parentSubject: Subject<any> = new Subject();
  removeSubject: Subject<any> = new Subject();
  talentpoolslist: any[] = []
  talentpooldetails: any;
  successMessage: string;
  errorMessage: string;
  selectedcandidate: any[] = []
  sortBy: string = 'new';
  recent: boolean = true;
  oldest: boolean;
  updateon: any;
  candidateTotalCount: any;
  /** Store all candidate numbers received in API resp */
  totalBulkCandidatesNumber: string[] = [];
  isBulkSelect: boolean = false;
  /** Store all candidates numbers which have been unselected AFTER bulk select via checkbox */
  excludedCandidatesAfterBulkSelect: string[] = [];
  /** Selected option from download CSV modal */
  bulkDownloadCSVSelectedOption: 'currentPage' | 'All' = null;
  /** Flag to determine CSV processing is ongoing */
  processingCSVDownload: boolean = false;
  selected: boolean;
  totalcandidatecount: any;
  talent_option: any = 'all';
  appliedFilters: any = {};
  emailFoundCount: number = 0;

  candidatesWithoutContactNumber: number = 0;

  @ViewChild('noEmailModal') noEmailModal: TemplateRef<any>
  @ViewChild('successModal') successModal: TemplateRef<any>;
  @ViewChild('errorModal') errorModal: TemplateRef<any>;
  @ViewChild('deleteTalentpool') deleteTalentpool: TemplateRef<any>;
  @ViewChild('removeCandidatefromTalentpool') removeCandidatefromTalentpool: TemplateRef<any>;
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  @ViewChild('addCandidateToScreenAiModal') addCandidateToScreenAiModal: TemplateRef<any>;
  @ViewChild('noCreditsSE') noCreditsSE: TemplateRef<any>;
  @ViewChild('upgradePlan') upgradePlan: TemplateRef<any>;
  @ViewChild('bulkemailerlimit') bulkemailerlimit: TemplateRef<any>;
  /** Bulk download as CSV modal ref */
  @ViewChild('bulkDownloadAsCSVModal') bulkDownloadAsCSVModal: TemplateRef<any>;

  start: number = 0;
  end: number = 0;
  total: any = 0;
  talentpipelinestates: any;
  coldtalent: any[] = [];
  warmtalent: any[] = [];
  hottalent: any[] = [];
  candidatedetails: any[] = [];
  contactdetails: any;
  talent_count: any;
  plandetails: string;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  currentFilters: any = []
  talentpoolnumber: any;
  isprofile: boolean = true;
  isSimilarCandidatesTabActive: boolean = false;
  isinsights: boolean
  currentexprience: any = []
  selectedcandidateForNote : any = []
  sortby: string
  pageNumber: number = 1;
  pageSize: number = 10;
  currentPage: number = 1;
  @Output() candidateEvent: EventEmitter<any> = new EventEmitter();
  candidateSubject:Subject<any> = new Subject();
  @Output() talenpoolrefreshEvent: EventEmitter<any> = new EventEmitter();
  @Output() talenttabsrefreshEvent: EventEmitter<any> = new EventEmitter();
  @Output() candidateCount : EventEmitter<any> = new EventEmitter();
  viewMore:boolean = false;
  showLookingForMore: boolean = false;
  appliedfiltercount: number;
  isSharedTalentpool: boolean = false;

  primaryCompanyInformation: any;
  currentCompanyInformation = {}
  campaignList: campaignModel[];
  campaign_input= new UntypedFormControl(null, [Validators.required]);
  job_input= new UntypedFormControl(null, [Validators.required]);
  selectedCampaign:{campaign_name : string, campaign_id : number};
  showLoaderOnCandidateList: Boolean = false;
  isCandidateSelected: boolean = false;

  jobList: any[] = [];
  selectedJob: any = null;

  // ScreenAI modal state
  screenAiDuplicateCheckDone: boolean = false;
  isLoadingScreenAiApi: boolean = false;
  postAddMssg: string = '';
  addCandidateSuccess: boolean = false;
  private destroy$ = new Subject<void>();

  /**Used for bulk reveal source key */
  enrichedFromForReveal: string = 'talenpool';
  /** To know the pending status of api*/
  isLoadingEmailCampaignApi: boolean = false;

  /**Bulk Reveal is in process or not */
  isBulkRevealInProcess: boolean = false;
  userEmailId: string = '';
  /**
   * Candidates without personal email or without contact number
   */
  candidatesWithoutContactInfo: number = 0;
  currentUser: any = null;

  /**
   * Data of Candidates which are selected for bulk reveal
   * Used to send data in Bulk Reveal Modal
   */
  selectedCandidateData: any = [];

  /**First name of user */
  firstNameUser: string = '';

  /**static messaging on top, regarding bulk reveal on talentpool level */
  bulkRevealBannerTalentpoolLevel: any = { showBanner: false, user: '', candidateCount: 0 };

  isFilterApplied: boolean = false;

  lastSelectedCandidateName: string = null;

 /**Number of  profiles in each page */
 profilesPerPage: number = 10;

  selectedSimilarCandidates: any[] = [];
  isSimilarCandidatesSelected: boolean = false;
  similarCandidatesEventEmitter: Subject<any> = new Subject();
  isLoadingForSimilarCandidates: boolean = false;
  @ViewChild('premiumUserError') premiumUserError: TemplateRef<any>;
  bulkRevealType: string;
  @Input() talentpoolDetails: any;
  checlIfFilterapplied:boolean=false

  createCandidateMode: string = 'select';
  /** This boolean controls whether both elements are "stuck" */
  isScrolled: boolean = false;
  /**The pixel threshold for activation */
  checkTalentpoolIsShared:boolean=false
  private readonly scrollThreshold = 55;
    @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;


  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isScrolled = verticalOffset >= this.scrollThreshold;
  }
  campaignName: string = '';
  isAegisConnected: boolean = false;


  constructor(private router: Router, public modalService: NgbModal, public candidateservice: CandidateService, public talentpoolservice: TalentpoolService,private personSearchService:PersonSearchService,
    private _localstorageservice: LocalStorageService,private excel :ExcelService ,private transactionservice : TransactionService,private route: ActivatedRoute, private emailCampaignService: CampaignService,
    private emailsettings: EmailsettingsService, @Inject(DOCUMENT) private document: Document, private atsResumeScreenService: AtsResumeScreenService, private aegisIntegrationService: AegisIntegrationService) {
      this.currentUser = parseInt(this._localstorageservice.getItem('userid') || 0);
    }

  ngOnInit() {
    this.checkAegisIntegrationConnected();
    this.firstNameUser = this._localstorageservice.getItem('userdata')['firstname'];

    const preferenceArray = this._localstorageservice.getItem('userdata').preferenceData;
    preferenceArray && preferenceArray.length && preferenceArray.map(item=>{
      if(item.listing_type == 'talentpool' && item.preference_type == 'page-size'){
        this.profilesPerPage = item.preference_value;
      }
    })

    this.candidateservice.GetCreatedCandidateData().subscribe(event => {
      this.talent_option = 'all'
    })

    this.talentpoolid = this.route.snapshot.params['id'];
    if (this.router.url.includes('suggestions')) {
      this.isprofile = false;
      this.isSimilarCandidatesTabActive = true;
    }
    this.talentpoolservice.talentPoolDetails.subscribe((talentPoolData) => {
      this.talentpoolslist = talentPoolData ? talentPoolData.talentpools : [];
    });
    if(this.talentpoolid) {
        const currentTalentpoolDetails = this.talentpoolslist ? this.talentpoolslist.filter((x) => { return x.talentpoolid == this.talentpoolid })[0] : null;
        if(currentTalentpoolDetails) {
          this.talentpooldetails = currentTalentpoolDetails;
          this.getTalentpoolSuggestedCandidatesCount();
        } else {
          this.isSharedTalentpool = true;
          const sharedTalentPoolData = this._localstorageservice.getItem('sharedTalentPoolDetails') ? JSON.parse(this._localstorageservice.getItem('sharedTalentPoolDetails')) : null;
          this.talentpooldetails = sharedTalentPoolData ? (sharedTalentPoolData.talentpools || []).find((tp: any) => tp.talentpoolid == this.talentpoolid) : null;
          this.getTalentpoolSuggestedCandidatesCount();
          if(!this.talentpooldetails) {
            this.getTalentpoolList();
            return;
          }
        }
        this.talentpoolnumber = this.talentpooldetails.talentpoolnumber
        this.getCandidateList()
    } else {
      this.getCandidateList()
    }

    if (this.router.url) {
      if (this.router.url.includes('talentpool')) {
        this.enrichedFromForReveal = 'talentpool';
      }
      else if (this.router.url.includes('candidate-list')) {
        this.enrichedFromForReveal = 'all-candidates'
      }
    }
    this.userEmailId = this._localstorageservice.getItem('usermailid');
    this.bulkRevealBannerStatus();

    this.getAllScreenAIJobs();

    /**
     * This handles search with debouncing for screenai jobs
     */
    this.job_input.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap((query: string) => {
          const q = (query || '').trim();
          return this.atsResumeScreenService.getAllScreenAIJobsBySource(q, 'create');
        }),
        takeUntil(this.destroy$)  // prevent memory leak
      )
      .subscribe((res: any) => {
        // Handle both the empty array shortcut and API response
        if (Array.isArray(res)) {
          this.jobList = res;
          return;
        }
        if (res.status === 'success') {
          this.jobList = res.data || [];
        }
      });
    let userid = this._localstorageservice.getItem('userid')
    let sharedTalenpoolCreatedby= this.talentpooldetails?.createdby

    if(userid === sharedTalenpoolCreatedby){
      this.checkTalentpoolIsShared = true
    }else{
      this.checkTalentpoolIsShared = false
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined as any);
    this.destroy$.complete();
  }

  openAddToEmailCampaignModal() {
    this.modalService.open(this.addCandidateToEmailCampaign);
  }
  /**
   * Computed property to get bulk-selected candidates after exclusions (for bulk selection across entire listing)
   */
  private get totalBulkCandidateNumbersAfterExclusions() {
    const excludedCandidatesSet = new Set(this.excludedCandidatesAfterBulkSelect);
    return this.totalBulkCandidatesNumber.filter(cand => !excludedCandidatesSet.has(cand));
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }


  pagination(type) {
    if (type == 'next') {
      this.start = this.start + 10
      this.end = this.start + 10
      if (this.end > this.total)
        this.end = this.total
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    } else if (type == 'prev') {
      this.start = this.start - 10
      this.end = this.start + 10
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    }
  }

  sortCandidateList(type, value) {
    if (type == 'recent') {
      this.sortBy = 'new'
      this.recent = true
      this.oldest = false
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    } else if (type == 'oldest') {
      this.sortBy = 'old'
      this.recent = false
      this.oldest = true
      // this.getTalentpoolList();
      this.removeSubject.next({ getFilter: true});
    }

    //if SortBy is Untick , Default
    if (value == false) {
      this.sortBy = 'new'
      this.removeSubject.next({ getFilter: true});
      // this.getTalentpoolList();
    }

  }

  getTalentpoolList() {
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe(async (res: any) => {
      if (res.status == "success") {
        this._localstorageservice.setItem('talentPoolDetails', JSON.stringify(res?.data) || null);
        this.talentpoolservice.setTalentPoolDetails(res?.data || null);
        this.talentpoolslist = res.data.talentpools
        this.talentpoolid = this.router.url.split('/')[3]
        const currentTalentpoolDetails = res.data.talentpools.filter((x) => { return x.talentpoolid == this.talentpoolid })[0];
        if(currentTalentpoolDetails) {
          this.talentpooldetails = currentTalentpoolDetails;
        } else {
          this.isSharedTalentpool = true;
          const resp = await this.talentpoolservice.getSharedTalentpoolsList(this._localstorageservice.getItem('usernumber')).toPromise();
          if(resp && resp.status === 'success') {
            this.talentpooldetails = (resp?.data?.talentpools || []).find((tp: any) => tp.talentpoolid == this.talentpoolid);
          }
        }
        this.talentpoolnumber = this.talentpooldetails.talentpoolnumber
        this.getCandidateList()
      }
    });


  }


  ChangeTalentStatus(type) {
    this.removeSubject.next({ removeFilter: true});
    if (type == 'all') {
      this.talent_option = 'all'
    } else {
      this.talent_option = type
    }
    this.start = 0
    this.appliedFilters = []
    this.selectAll(false)
   // this.getTalentpoolList();
  }

  getCandidateList(val = null, source?: string) {
    if (!source || (source && source != 'fromSlider')) {
      this.showLoaderOnCandidateList = true;
    }

    if((this.appliedFilters && this.appliedFilters && Object.keys(this.appliedFilters).length) < (val && val.payload && Object.keys(val.payload).length)){
      this.start = 0;
    }
   // this.appliedFilters = val ? val.payload : '';
    if(val && val.isReset == true){
      this.start = 0
    }
    let data = {
      startingfrom: this.start,
      resultsize: this.profilesPerPage ? this.profilesPerPage : 10,
      usernumber: this._localstorageservice.getItem('usernumber'),
      ...this.appliedFilters,
      sortby: this.sortBy || 'new'
    }

    if (this.talent_option == 'all') {
      data['pipelinestatus'] = "'Hot', 'Warm', 'Cold'"
    } else {
      data['pipelinestatus'] = "'" + this.talent_option + "'"
    }

    if(this.talentpooldetails && this.talentpooldetails.talentpoolnumber){
      data['talentpoolnumber'] = this.talentpooldetails.talentpoolnumber
    }
    if(this.sortby) {
      data['sortby'] = this.sortby
    }
    this.candidateservice.getCandidateList(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.excludedCandidatesAfterBulkSelect = [];
        this.totalcandidatecount = res.data.candidatedetails.length;
        this.showLoaderOnCandidateList = false;
        this.bulkRevealPayloadTalentpoolLevel(res?.data?.candidatesWitoutContactDetail);

        // this.candidateTotalCount = res.data.allcandidatescount
        this.candidateTotalCount = res.data.candidatenumbers.length
        this.talentpoolservice.setAllCandidateDetails(res?.data || null);
        this.talenpoolrefreshEvent.emit('refresh')
        this.candidateEvent.emit(this.candidateTotalCount)
        this.candidateCount.emit({filteredCandidateCount: this.candidateTotalCount, filterApplied:this.checlIfFilterapplied})
        this.totalBulkCandidatesNumber = res.data.candidatenumbers
       // this.talentpipelinestates = res.data.totalcountindifferentpipelinestatus
        this.candidatedetails = res.data.candidatedetails
        this.candidatelist = res.data.candidatedetails.map(x => x.basicdetails)
        // this.coldtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Cold' })
        // this.warmtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Warm' })
        // this.hottalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Hot' })
        this.candidatedetails.map(res=>{
          let companyWebsiteDetails = res.experienceDetails.find(x => x.companyname === res.basicdetails.companyname)
          if(companyWebsiteDetails && companyWebsiteDetails.website){
            res.basicdetails.website = res.experienceDetails.find(x => x.companyname === res.basicdetails.companyname).website
          }
          res.currentexprience = res.experienceDetails && res.experienceDetails.filter(x=>x.iscurrent == 1)
          res.currentexprience = _.sortBy(res.currentexprience, 'startdate').reverse()
          if(res.currentexprience.length > 0) {
            const startDate = res.currentexprience[0].startdate ? moment(res.currentexprience[0].startdate) : null;
            const endDate = moment(res.currentexprience[0].enddate || new Date());
            const totalTenure = endDate.diff(startDate, 'years', true);
            res.currenttenure = this.getFormattedTenure(totalTenure);
          }
          res.pastexperience = res.experienceDetails.filter(obj => obj.iscurrent != 1);
          res.pastexperience.map(x=>{
            const startDate = x.startdate ? moment(x.startdate) : null;
            const endDate = moment(x.enddate || new Date());
            const totalTenure = endDate.diff(startDate, 'years', true);
            x.totaltenure = this.getFormattedTenure(totalTenure);
            return x;
          })
          if(res.contactdetails.socialprofiles) {
            if(res.contactdetails.socialprofiles.existingDetails.length > 0) {
              res.linkedin_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'linkedin')[0]
              res.facebook_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'facebook')[0]
              res.twitter_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'twitter')[0]
              res.github_url = res.contactdetails.socialprofiles.existingDetails.filter(x=>x.platformname == 'github')[0]
            }
            if(res.contactdetails.socialprofiles.moreAvailableDetails.length > 0) {
              res.linkedin_url = res.linkedin_url ? res.linkedin_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'linkedin')[0]
              res.facebook_url = res.facebook_url ? res.facebook_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'facebook')[0]
              res.twitter_url = res.twitter_url ? res.twitter_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'twitter')[0]
              res.github_url = res.github_url? res.github_url: res.contactdetails.socialprofiles.moreAvailableDetails.filter(x=>x.platformname == 'github')[0]

            }
          }
          if(res.lastcandidateactivity.length > 0) {
            res.lastactivity = this.getActivityText(res.lastcandidateactivity[0])
          }
          res.personal_email = []
          res.work_email = []
          res.mobile_phone =[]



              if(res.contactdetails){
                if(res.contactdetails.emails && res.contactdetails.emails.existingDetails || res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails){
                  if((res.contactdetails.emails && res.contactdetails.emails.existingDetails.length > 0) || (res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails.length > 0)){
                    let professionalCount
                    let personalCount

                    if(res.contactdetails.emails && res.contactdetails.emails.existingDetails && res.contactdetails.emails.existingDetails.length){
                      let conedEmail =__.cloneDeep(res.contactdetails.emails)
                      professionalCount = conedEmail.existingDetails.filter(x => x.contactdetailcategory == 'professional')
                      personalCount = conedEmail.existingDetails.filter(x => x.contactdetailcategory == 'personal')

                    }

                    let phoneCount;
                    if(res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails && res.contactdetails.contactnumbers.existingDetails.length){
                      let conedContact =__.cloneDeep(res.contactdetails.contactnumbers)

                      phoneCount = conedContact.existingDetails.filter(x => x.type == 'contactnumber')
                    }


                    if(professionalCount && professionalCount.length && personalCount && personalCount.length && phoneCount && phoneCount.length){
                      res.canShowLookingMore = false
                    }else{
                      res.canShowLookingMore = true
                    }
                  }
                }
              }



          if(res.contactdetails.emails) {
            if(res.contactdetails.emails.existingDetails.length > 0) {
              res.personal_email = res.contactdetails.emails.existingDetails.filter(x=>x.contactdetailcategory == "personal" )
              res.work_email = res.contactdetails.emails.existingDetails.filter(x=>(x.contactdetailcategory == 'work' || x.contactdetailcategory == 'professional' || x.contactdetailcategory == 'current_professional'))
            }
          } else {
            res.personal_email = undefined;
            res.work_email = undefined;
          }
          if(res.contactdetails.contactnumbers) {
            if(res.contactdetails.contactnumbers.existingDetails.length > 0) {
              res.mobile_phone = res.contactdetails.contactnumbers.existingDetails.filter(x=>x.type == 'contactnumber' )
            }
          } else {
            res.mobile_phone = undefined;
          }
          if((!res.contactdetails.emails || (res.contactdetails.emails && res.contactdetails.emails.existingDetails.length == 0))) {
            res.hasemailreveal = true
          } else {
            res.hasemailreveal = false
          }

          if(!res.contactdetails.contactnumbers || (res.contactdetails.contactnumbers && res.contactdetails.contactnumbers.existingDetails.length == 0)) {
            res.hascontactreveal = true
          } else {
            res.hascontactreveal = false
          }

          // if((!res.contactdetails.emails) || (!res.contactdetails.contact)) {
          //   res.hasnorevealinfo = true
          // } else {
          //   res.hasnorevealinfo = false
          // }

          return res;
        })

        // if(this.candidatedetails['pastexperience'] && this.candidatedetails['pastexperience'].length > 0) {
        //   this.candidatedetails['pastexperience'].map(res=>{
        //     const startDate = res.startdate ? moment(res.startdate) : null;
        //     const endDate = moment(res.enddate || new Date());
        //     const totalTenure = endDate.diff(startDate, 'years', true);
        //     res.totaltenure = this.getFormattedTenure(totalTenure);
        //     return res;
        //   })
        // }

        this.candidatedetails.map(x => {
          return x.basicdetails['updatedon'] = GlobalService.getDates(x.basicdetails['updatedon']).text;
        })

        if (this.talent_option == 'all') {
          this.talent_count = this.candidateTotalCount
        } else if (this.talent_option == 'Hot') {
          this.talent_count = this.hottalent[0].count
        }
        else if (this.talent_option == 'Warm') {
          this.talent_count = this.warmtalent[0].count
        }
        else if (this.talent_option == 'Cold') {
          this.talent_count = this.coldtalent[0].count
        }

        this.total = this.talent_count
        if (this.start == 0) {
          if (this.end > this.total) {
            this.end = this.total
          }
          if (this.total == 0) {
            this.start = this.total;
            this.end = this.total
          } else if (this.total < 10) {
            this.end = this.total
          } else {
            this.end = this.start + 10;
          }
        }

        if (this.talent_option == 'all') {
          this.talent_count = this.candidateTotalCount
        }
      }
      this.route.queryParams.subscribe(params => {
        const candidateNumber = params['candidatenumber'];
        const elastic_id = params['elastic_id'];
        const tabName = params['tab_name']
        if(candidateNumber != null){
          const candidateData = {
            candidatenumber: candidateNumber,
            elastic_id: elastic_id
          }
          const tabToOpen = (tabName == 'contact') ? 'contact' : 'details';
          this.OpenCandidateSlider(candidateData, tabToOpen)
        }
      });


    })

  }

  /**
   * Update preference of profiles per page on listing
   */
  updatePagePreference() {
    const data = {
      preference_type: 'page-size',
      preference_value: this.profilesPerPage,
      listing_type: 'talentpool'
    }
    this.currentPage = 1;
    try {
      this.personSearchService.updatePagePreference(data);
      this.setPage(1);
    } catch {
      this.toastmessage("Something went wrong", 'error');
    }
  }

  /**
   * Create a payload for bulk reveal,
   * candidates will be selected from completee talentpool, whose contact details are not present.
   * @param candidatesWitoutContactDetail array of candidates having no contact details
   */
  bulkRevealPayloadTalentpoolLevel(candidatesWitoutContactDetail) {
    const bulkRevealPayLoad = {
      enrichedFrom: this.enrichedFromForReveal,
      talentpoolnumber: this.talentpoolnumber,
      candidates: []
    }
    if(candidatesWitoutContactDetail){
      if (candidatesWitoutContactDetail && candidatesWitoutContactDetail.length) {
        candidatesWitoutContactDetail.map(x => {
          if (!x?.bulkcontactrevealstatus && x.elastic_id) {
            bulkRevealPayLoad.candidates.push({
              elastic_id: x.elastic_id,
              talentpoolcandidatemappingid: x?.talentpoolcandidatemappingid
            })
          }
        })
      }
    }

    this.bulkRevealBannerTalentpoolLevel = {
      showBanner: (bulkRevealPayLoad.candidates.length > 1) ? true : false,
      candidateCount: bulkRevealPayLoad.candidates.length,
      user: this.firstNameUser,
      bulkRevealPayLoad: bulkRevealPayLoad
    }
  }

  /**
   * Open Bulk Reveal modal, When find contacts from banner
   * @param bulkRevealPayLoad Payload for bulk reveal
   */
  openBulkRevealModal(bulkRevealPayLoad) {
    const modalObj = {
      calledFor:'talentpool',
      total_target: bulkRevealPayLoad.candidates.length,
      emailsFound: 0,
      payload: bulkRevealPayLoad,
      campaign_id: null,
      onTalentpoolLevel: true
    }
    this.bulkRevealType = "Banner";
    this.openDetailsModal(modalObj);
  }

  setPage(index: number) {
    this.resetAllSelections();
    this.selectedcandidate = [];
    this.selectedSimilarCandidates = [];
    this.selected = false;
    let start = (index - 1) * this.profilesPerPage
    this.start = start
    this.end = this.start + this.profilesPerPage

    if(this.isSimilarCandidatesTabActive) {
      this.similarCandidatesEventEmitter.next({ action: 'PAGE_CHANGE', data: { page: index, start: this.start, pageSize: this.profilesPerPage } });
    } else {
      if (this.end > this.candidateTotalCount) {
        this.end = this.candidateTotalCount
      }
      this.getCandidateList();
      this.document.documentElement.scrollTop = 0;
      this.bulkRevealBannerStatus();
    }
  }
  getTalentpoolCandidate(talentpoolnumber) {
    let data = {
      talentpoolnumber: talentpoolnumber,
      startingfrom: this.start,
      usernumber: this._localstorageservice.getItem('usernumber')
    }
    if (this.talent_option == 'all') {
      data['pipelinestatus'] = "'Hot', 'Warm', 'Cold'"
    } else {
      data['pipelinestatus'] = "'" + this.talent_option + "'"
    }
    this.candidateservice.getCandidateList(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.totalcandidatecount = res.data.candidatedetails.length;
        this.candidateTotalCount = res.data.totalcandidatesintalentpool
        this.totalBulkCandidatesNumber = res.data.candidatenumbers
       // this.talentpipelinestates = res.data.totalcountindifferentpipelinestatus
        this.candidatedetails = res.data.candidatedetails
        this.candidatelist = res.data.candidatedetails.map(x => x.basicdetails)
        // this.coldtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Cold' })
        // this.warmtalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Warm' })
        // this.hottalent = this.talentpipelinestates.filter((x: any) => { return x.pipelinestatus == 'Hot' })
        this.candidatedetails.map(x => {
          return x.basicdetails['updatedon'] = GlobalService.getDates(x.basicdetails['updatedon']).text;
        })
      }
      if (this.talent_option == 'all') {
        this.talent_count = this.candidateTotalCount
      } else if (this.talent_option == 'Hot') {
        this.talent_count = this.hottalent[0].count
      }
      else if (this.talent_option == 'Warm') {
        this.talent_count = this.warmtalent[0].count
      }
      else if (this.talent_option == 'Cold') {
        this.talent_count = this.coldtalent[0].count
      }

      this.total = this.talent_count
      if (this.start == 0) {
        if (this.end > this.total) {
          this.end = this.total
        }
        if (this.total == 0) {
          this.start = this.total;
          this.end = this.total
        } else if (this.total < 10) {
          this.end = this.total
        } else {
          this.end = this.start + 10;
        }
      }
    })
  }

  /**
   * select one candidate
   * @param candidate
   * @param value
   */
  checkIfAllSelected(candidate, event) {
    let value = event.target.checked
    if (value == true) {
      this.isCandidateSelected = true;
      this.selectedcandidate.push(candidate.basicdetails.candidatenumber)
      this.selectedcandidateForNote.push({candidatenumber : candidate.basicdetails.candidatenumber,basicdetails : candidate.basicdetails})
      const excludedCandidateIndex = this.excludedCandidatesAfterBulkSelect.findIndex(can => can === candidate?.basicdetails?.candidatenumber);
      if (excludedCandidateIndex !== -1) {
        this.excludedCandidatesAfterBulkSelect.splice(excludedCandidateIndex, 1);
      }
      if(this.selectedcandidate.length == this.totalcandidatecount) {
        this.selected = true
        this.excludedCandidatesAfterBulkSelect = []
      }
    } else {
      if(this.isBulkSelect) {
        this.excludedCandidatesAfterBulkSelect.push(candidate?.basicdetails?.candidatenumber);
      }
      this.selectedcandidate = _.without(this.selectedcandidate, candidate.basicdetails.candidatenumber);
      this.selectedcandidateForNote =  this.selectedcandidateForNote.filter((item) => item.candidatenumber != candidate.basicdetails.candidatenumber);
      this.selected = false
    }
    if (candidate?.basicdetails?.firstname || candidate?.basicdetails?.lastname) {
      this.lastSelectedCandidateName = '';
      if (candidate?.basicdetails?.firstname) this.lastSelectedCandidateName += candidate.basicdetails.firstname;
      if (candidate?.basicdetails?.lastname) this.lastSelectedCandidateName += ' ' + candidate.basicdetails.lastname;
    }
    /**To calculate the number of profiles with personal email or contact number */
    this.bulkRevealPayload();
  }

  /**
   * select all candidates
   * @param event
   */
  selectAll(event: any) {
    const value = (event.target as HTMLInputElement) && (event.target as HTMLInputElement).checked ? true : false;
    if (value == true) {
      if(this.isprofile) {
        this.isBulkSelect = true;
        this.isCandidateSelected = true;
        this.selectedcandidate = []
        this.selectedcandidateForNote = []
        this.candidatedetails.forEach((element, index) => {
          this.candidatedetails[index].selected = true;
          this.selectedcandidate.push(element.basicdetails.candidatenumber)
          this.selectedcandidateForNote.push({candidatenumber : element.basicdetails.candidatenumber,basicdetails : element.basicdetails})
        })
      } else {
        this.similarCandidatesEventEmitter.next({ action: 'BULK_SELECTION', data: { value: true } });
      }
    } else if (value == false) {
      if(this.isprofile) {
        this.isCandidateSelected = false;
        this.candidatedetails.forEach((element, index) => {
          this.candidatedetails[index].selected = false;
          this.selectedcandidate = []
          this.selectedcandidateForNote = []
        })
        this.isBulkSelect = false;
        this.selected = false;
        this.excludedCandidatesAfterBulkSelect = [];
      } else {
        this.similarCandidatesEventEmitter.next({ action: 'BULK_SELECTION', data: { value: false } });
      }
    }
     /**To calculate the number of profiles with personal email or contact number */
     this.isprofile && this.bulkRevealPayload();
  }

  /**
   * Reset all selections in the current listing
   */
  resetAllSelections() {
    this.selected = false;
    this.isBulkSelect = false;
    this.excludedCandidatesAfterBulkSelect = [];
    this.selectedcandidate = [];
    this.candidatedetails.forEach(cand => cand.selected = false);
  }

  //Bulk Candidate Select All from Database
  getAllActiveCandidates() {
    this.selectedcandidate = this.totalBulkCandidatesNumber
    this.isBulkSelect = true

  }


  //Confirmation Modal to Remove Candiate from TAlentpool
  RemoveBulkCandidatesFromTalentpoolModal() {
    const confirmRef = this.modalService.open(this.removeCandidatefromTalentpool, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  /**
   * remove selected candidate/candidates from talentpool
   */

  removecandidatefromtalentpool() {
    this.isFilterApplied = false;
    if(this.talentpoolid) {
      let candidateobject = [];
      for (let candidate of this.selectedcandidate) {
        candidateobject.push({
          candidatenumber: candidate,
        })
      }
      let data = {
        talentpoolnumber: this.talentpooldetails.talentpoolnumber,
        candidateidList: candidateobject,
        usernumber: this._localstorageservice.getItem('usernumber')
      }


      this.talentpoolservice.removeCandidatefromTalentpool(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.modalService.dismissAll();
          this.talenpoolrefreshEvent.emit('refresh')
          this.talenttabsrefreshEvent.emit('refresh')
          this.toastmessage("Selected Candidates Removed from Talentpool Succesfully", "success")
          this.getCandidateList();
          this.selectAll(false)
        }
        else {
          this.modalService.dismissAll();
          this.toastmessage("Something went Wrong", "error")
        }
      })
    } else {
      let data = {
        candidatenumber: this.selectedcandidate.length > 1 ? this.selectedcandidate: this.selectedcandidate[0]
      }
      this.candidateservice.deleteAllCandidates(data).subscribe((res:any)=>{
        if (res.status == 'success') {
          this.modalService.dismissAll();
          this.toastmessage("Candidates archived successfully", "success")
          this.talenpoolrefreshEvent.emit('refresh')
          this.talenttabsrefreshEvent.emit('refresh')
          this.getCandidateList();
          this.selectAll(false)
        }
        else {
          this.modalService.dismissAll();
          this.toastmessage("Something went Wrong", "error")
        }
      })
    }

  }


  openAddTalentpoolModal(candidate) {
    const modalRef = this.modalService.open(AddToTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = candidate ? candidate.basicdetails: []
    modalRef.componentInstance.BuldCandidatetoAdd = this.selectedcandidate
    modalRef.componentInstance.type = 'candidate'
    modalRef.componentInstance.lastSelectedCandidateName = this.lastSelectedCandidateName;
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'candidateAdded') {
        this.toastmessage('Candidate Added to Talentpool Succesfully', 'success')
      //  this.getTalentpoolList()
        this.selectAll(false)
      } else if (x == 'alreadyexist') {
        this.toastmessage('Candidate has already been added to this talentpool', 'error')
      }else if (x == 'Missing parameters') {
        this.toastmessage('Unable to add profile to the talent pool. Please try again.', 'error')
      }else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
      this.candidatedetails = this.candidatedetails.map(c => ({...c, selected: false}));
    })
  }

  OpenCandidateSlider(candidate, type, bulkRevealData = null) {
    document.getElementById("mySidebar2").style.display = "block";
    document.getElementById("myOverlay2").style.display = "block";
    console.log(bulkRevealData, 'bulkRevealData in candidate slider in listing')
    this.parentSubject.next({ candidatenumber: candidate.candidatenumber, tabtoShow: type, elasticid: candidate.elastic_id, candidateId: this.candidatedetails.filter(x=>x.basicdetails.candidatenumber==candidate.candidatenumber) && this.candidatedetails.filter(x=>x.basicdetails.candidatenumber==candidate.candidatenumber).length ? this.candidatedetails.filter(x=>x.basicdetails.candidatenumber==candidate.candidatenumber)[0].candidateid: null, bulkContactStatus: bulkRevealData?.bulkcontactrevealstatus  });
  }

  opensliderforContacts(candidate, type) {
    document.getElementById("mySidebar2").style.display = "block";
    document.getElementById("myOverlay2").style.display = "block";
    this.parentSubject.next({ candidatenumber: candidate.candidatenumber, tabtoShow: type, elasticid: candidate.elastic_id, bulkContactStatus: candidate?.talentpoolMappingDetails?.bulkcontactrevealstatus  });
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // loadn[0].style.display = 'none'
  }


  OpenCandidateList(type) {
    if (type == 'all') {
      this.router.navigateByUrl("/candidate-list")
    }
    else {
      let talentpoolid = type.talentpoolid
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['candidate-list/talentpool/' + talentpoolid]));
      this.talentpoolview = true;
    }
  }


  openAddNOtesModal(candidate) {
    const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.noteforCandidate = candidate ? candidate.basicdetails  : null
    modalRef.componentInstance.BuldnoteforCandidate = this.selectedcandidateForNote
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'noteAdded') {
        this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
        this.getCandidateList()
        this.selectAll(false)

      } else if (x == 'error') {
        this.toastmessage('Something went Wrong, Please try again in a minute', 'error')
      }
    })
  }

  openCallLogModal(candidate) {
    const modalRef = this.modalService.open(CallLogComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.calllogforCandidate = candidate ? candidate : null
    modalRef.componentInstance.BulkcalllogforCandidate = this.selectedcandidate
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'calllogAdded') {
        this.toastmessage('Call Logs Added for Candidate Succesfully', 'success')
        this.selectAll(false)
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
    })
  }


  openSendBulkEmailModal(candidate) {
    if(this._localstorageservice.getItem('secredits') >= this.selectedcandidate.length){
    if (candidate || this.selectedcandidate.length <= 10) {
      const modalRef = this.modalService.open(CandidateEmailComponent, { size: 'lg' as 'lg', centered: true });
      modalRef.componentInstance.emailforCandidate = candidate ? candidate : null
      let selectedemailcandidates = []
      if(this.selectedcandidate.length > 0){
        this.selectedcandidate.forEach((element, index) => {
          selectedemailcandidates.push(this.candidatedetails.filter((x)=> {return x.basicdetails.candidatenumber == element }))
        })
      }
      modalRef.componentInstance.BulkCandidateEmail = selectedemailcandidates
      modalRef.componentInstance.passEntry.subscribe((x) => {
        if (x == 'emailsend') {
          this.toastmessage('Email Send Successfully', 'success')
          this.selectAll(false)
          setTimeout(()=>{
            this.fetchcredits()
          },1000)

        } else if (x == 'error') {
          this.toastmessage('Something went Wrong', 'error')
        } else if (x == 'limitexceeded') {
          this.toastmessage('mail limit exceeded', 'error')
        } else if (x == 'nocredits') {
          this.modalService.open(this.noCreditsSE,{ windowClass: "myCustomModalClass", centered: true });
          this.sendmailexpiry('Smart Email credits')
        } else if(x == 'noEmail'){
          this.modalService.open(this.noEmailModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        }

      })
    } else {
      this.modalService.open(this.bulkemailerlimit, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false })
    }
    }else{
      this.sendmailexpiry('Smart Email credits')
      this.modalService.open(this.noCreditsSE,{ windowClass: "myCustomModalClass", centered: true });
    }
  }

  DeleteTalentpoolConfirmation() {
    const confirmRef = this.modalService.open(this.deleteTalentpool, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  DeleteTalentpool() {
    let data = {
      talentpoolnumber: this.talentpooldetails.talentpoolnumber,
      usernumber: this._localstorageservice.getItem('usernumber')
    }

    this.talentpoolservice.RemoveTalentpoolDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.successMessage = "Talentpool Deleted Successfully"
        this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        this.router.navigate(['candidate-list'])
        this.fetchcredits()
      }
      else {
        this.errorMessage = "Something Went Wrong"
        this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      }
    })
  }

  EditTalentpoolDetails() {
    const modalRef = this.modalService.open(CreateTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.TalentpoolIDtoEdit = this.talentpooldetails.talentpoolnumber
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'talentpool-edited') {
        this.toastmessage("Talentpool Edited Successfully", 'success')
      }
    })
  }

  /**
   * dealing with inconsistent data types from local storage
   */
  safeParseTalentPool(value: any): any {
    if (typeof value === 'object' && value !== null) {
        return value;
    }

    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        } catch (e) {
            console.warn('Failed to parse talent pool string:', e);
            return {};
        }
    }

    return {};
  }

  /**
   * Trigger confirmation modal for bulk-download candidates CSV
   */
  triggerBulkDownloadCandidatesCSVModal() {
    this.modalService.open(this.bulkDownloadAsCSVModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Bulk download candidates to CSV via service call & generating CSV file
   */
  async DownloadCandidateCSV(){
    if(this.plandetails !='Free'){
      this.processingCSVDownload = true;
      const candidatesToDownloadAsCSV = this.bulkDownloadCSVSelectedOption == 'All' ? this.totalBulkCandidateNumbersAfterExclusions : this.selectedcandidate;

      const data = {
        candidatenumbersarray: candidatesToDownloadAsCSV,
        usernumber:this._localstorageservice.getItem('usernumber')
      }
    this.candidateservice.fetchcandidatedetailsforcsvdownload(data).subscribe(async (res:any)=>{
      if(res.status == 'failure' && res.message =='free plan user'){
        this.modalService.open(this.upgradePlan,{ windowClass: "myCustomModalClass", centered: true });
      }else{
    let canddiatedata = res.data.filter((x: any) => x.firstname || x.lastname);

    let downloadobj = [];
    let headers = `First Name,Last Name,Source,Created by,Talent Pipeline,Social Profile URL,Primary Email ID,Primary Contact Number,All Social Profile URLs,All Emails,All Contact Numbers,Job Title,Company Name,Work Location,Experience Start Date,Experience End Date,Past Job Titles,Skills,Name of School,Degree,Start Year,End Year,Notes,Tags`;
    const talentPoolDetails = this.safeParseTalentPool(this._localstorageservice.getItem('talentPoolDetails'));
    const currentTalentPool = talentPoolDetails?.talentpools?.find(
      (item) => item.talentpoolid === this.talentpooldetails?.talentpoolid
    );
    let filename = `${currentTalentPool?.name ?? "Webbtree candidates"}~${moment().format('DD MMM YY')}~${this.bulkDownloadCSVSelectedOption === 'All' ? this.totalBulkCandidateNumbersAfterExclusions.length : this.selectedcandidate.length} profiles`
    canddiatedata.forEach(data => {
      let candidatelistobj = {};
      let headersmain = headers.split(",");

      headersmain.forEach((headers) => {
        let headersbe = headers
          .split(" ")
          .join("")
          .toLowerCase();

        if (headersbe == "firstname") {
          if (data["firstname"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["firstname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "lastname") {
          if (data["lastname"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["lastname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "source") {
          if (data["source"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["source"].replace(/[\[\]']+/g,''));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "createdby") {
          if (data["createdby"] != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data["createdby"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'talentpipeline') {
          if (data['talentpoolsarray'].length != 0) {
            candidatelistobj[headers] = data["talentpoolsarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else if (headersbe == 'socialprofileurl') {
          if (data['profileurl'] != null) {
            candidatelistobj[headers] = data["profileurl"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else if (headersbe == 'primaryemailid') {
          if (data['primaryemailid']) {
            candidatelistobj[headers] = data["primaryemailid"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else if (headersbe == 'primarycontactnumber') {
          if (data['primarycontactnumber']) {
            candidatelistobj[headers] = data["primarycontactnumber"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'allsocialprofileurls') {
          if (data['allsocialprofilesarray'].length != 0) {
            candidatelistobj[headers] = data["allsocialprofilesarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'allemails') {
          if (data['allemailsarray'].length != 0) {
            candidatelistobj[headers] = data["allemailsarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'allcontactnumbers') {
          if (data['allcontactnumbersarray'].length != 0) {
            candidatelistobj[headers] = data["allcontactnumbersarray"].join(', ');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'jobtitle') {
          if (data['jobtitle']) {
            candidatelistobj[headers] = GlobalService.titleCase(data["jobtitle"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'companyname') {
          if (data['companyname']) {
            candidatelistobj[headers] = GlobalService.titleCase(data["companyname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'worklocation') {
          if (data['locationname']) {
            candidatelistobj[headers] = GlobalService.titleCase(data["locationname"]);
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'experiencestartdate') {
          if (data['experiencestartdate'] != null) {
            candidatelistobj[headers] = moment(data["experiencestartdate"]).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'experienceenddate') {
          if (data['experienceenddate'] != null) {
            candidatelistobj[headers] = moment(data["experienceenddate"]).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'Present';
          }
        } else if(headersbe == 'pastjobtitles') {
          if (data['allPastJobTitles'].length) {
            candidatelistobj[headers] = GlobalService.titleCase(data["allPastJobTitles"].join(', '));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'skills') {
          if (data['allskillsarray'].length) {
            candidatelistobj[headers] = GlobalService.titleCase(data["allskillsarray"].join(', '));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'nameofschool') {
          if (data['educationdetails'] && data['educationdetails'].institutename != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data['educationdetails'].institutename)
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'degree') {
          if (data['educationdetails'] && data['educationdetails'].degree != null) {
            candidatelistobj[headers] = GlobalService.titleCase(data['educationdetails'].degree)
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }else if (headersbe == 'startyear') {
          if (data['educationdetails'] && data['educationdetails'].startdate != null) {
            candidatelistobj[headers] = moment(data['educationdetails'].startdate).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'endyear') {
          if (data['educationdetails'] && data['educationdetails'].enddate != null) {
            candidatelistobj[headers] = moment(data['educationdetails'].enddate).format('YYYY-MM');
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }  else if (headersbe == 'notes') {
          if (data['allnotesarray'] && data['allnotesarray'].length > 0) {
            data['allnotesarray'] = data['allnotesarray'].map(x =>{
              let res = x
              res = "{" + x + "}"
              return res
            })
            candidatelistobj[headers] = data['allnotesarray'].toString()
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == 'tags') {
          if (data['alltagsarray'] && data['alltagsarray'].length > 0) {
            candidatelistobj[headers] = GlobalService.titleCase(data['alltagsarray'].join(', '));
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
        else {
          if (data[headersbe] != null) {
            candidatelistobj[headers] = data[headersbe];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
      });
      if (!_.isEmpty(candidatelistobj)) {
        downloadobj.push(candidatelistobj);
      }
    });

    let newobj = [];
    downloadobj.forEach(element => {
      newobj.push(Object.values(element));
    });

    try {

      // generate excel file
      filename = filename + (this.bulkDownloadCSVSelectedOption === 'All' ? '.xlsx' : '')
      const excelFile: Blob = await this.excel.exportAsExcelFile(
        newobj,
        filename,
        headers.split(","),
        null,
        this.bulkDownloadCSVSelectedOption == 'currentPage' // for current page, download on FE, else send over email
      );

      if(this.bulkDownloadCSVSelectedOption == 'All') {
        // convert excel file to base64 to be able to attach in email
        const base64FileData = await GlobalService.toBase64(excelFile)
        const emailPayload = {
          from: "Webbtree <notification@webbtree.com>",
          recipientEmails: [this._localstorageservice.getItem('userdata')?.loginemail],
          subject: "Webbtree Talent Discovery | Download Profiles as CSV",
          template: `Hi {{user.firstname}} {{user.lastname}},
                    <br/><br/>Please find attached the CSV file which has been downloaded for the selected profiles on the Webbtree Talent Discovery platform.
                    <br/><br/>Thanks and Regards,
                    <br />Team Webbtree`,
          attachments: [{ filename, path: base64FileData }],
          updatedby: this._localstorageservice.getItem('userdata')?.userid
        }
        // send email
        const sendEmailResp: any = await this.emailsettings.sendbulkemail(emailPayload).toPromise();
        if (sendEmailResp && sendEmailResp.status == "success") {
          this.successMessage = "You will receive the CSV file on your email in a min.";
        } else {
          this.errorMessage = "Something went wrong";
        }
      }

    } catch (e) {
      console.log("DownloadCandidateCSV() error - ", e);
      this.errorMessage = "Something went wrong";
    }
  }
      setTimeout(() => {
        this.successMessage = "";
        this.successMessage = "";
      }, 5000);
      this.processingCSVDownload = false;
      // reset all selections in listing
      this.resetAllSelections();
      this.closeActiveModal();
  })
  }else{
    this.modalService.open(this.upgradePlan,{ windowClass: "myCustomModalClass", centered: true });
  }

  }

  route2pricing(){
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/pricing')
  }

  fetchcredits(){
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const res: any = { data: this.transactionservice.credits() };
    if (res.data) {
        this.plandetails = res.data.plancost == 'free' ? 'Free' : 'Premium'
        if (res.data.isteamadmin) {
          // Here the logged in person is a Team Admin
          this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
          this.subscriptiondetails.balancejdparsingcredits = res.data.pooledbalancejdparsingcredits;
          this.subscriptiondetails.balancesmartemailcredits = res.data.pooledbalancesmartemailcredits;
          this.subscriptiondetails.balancetalentpipelinecredits = res.data.pooledbalancetalentpipelinecredits;
        } else {
          if (res.data.teamadmindetails) {
            // Here the logged in person is a Team Member
            this.isteamMember = true
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.teamadmindetails.adminbalancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.teamadmindetails.adminbalancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.teamadmindetails.adminbalancetalentpipelinecredits;
          } else {
            // Here the logged in person is a normal (who does not belong to any team)
            this.subscriptiondetails.balancecontactenrichmentcredits = res.data.balancecontactenrichmentcredits;
            this.subscriptiondetails.balancejdparsingcredits = res.data.balancejdparsingcredits;
            this.subscriptiondetails.balancesmartemailcredits = res.data.balancesmartemailcredits;
            this.subscriptiondetails.balancetalentpipelinecredits = res.data.balancetalentpipelinecredits;
          }
        }
        this._localstorageservice.setItem('jdcredits', this.subscriptiondetails.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', this.subscriptiondetails.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', this.subscriptiondetails.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', this.subscriptiondetails.balancesmartemailcredits)
      }
  }

  sendmailexpiry(type){
    let data ={
      expiredmetric : type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }

  filterSlider_open(){
    document.getElementById("mySidebar_filter").style.display = "block";
    document.getElementById("myOverlay_filter").style.display = "block";
    if (this.talentpoolnumber) {
      this.removeSubject.next({ talentpoolnumber: this.talentpoolnumber });
    }
  }
  filterJobs(data) {
    this.currentPage = 1;
    this.start = 0; // Whenever any filter applies, pagination set to initial state.
    this.appliedFilters = data ? data.payload : ''
    this.appliedfiltercount = data.payload.filtercount
     if(this.appliedfiltercount > 0){
      this.checlIfFilterapplied = true
    }else{
      this.checlIfFilterapplied = false
     }
     this.getCandidateList(data);
     this.talenpoolrefreshEvent.emit('refresh')
     this.talenttabsrefreshEvent.emit(this.appliedFilters)

     if(this.appliedFilters && Object.keys(this.appliedFilters).length && this.appliedFilters.filtercount >= 1){
      this.isFilterApplied = true;
     }

  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    let strValue: string;

    if (Array.isArray(value)) {
      strValue = value[0] || '';
    } else {
      strValue = value;
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = strValue.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, (char: string) => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  isBoolean() {

  }
/**
 * get format for totalexperience
 * @param tenure
 * @returns
 */

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  viewmoredetails(data, i, type) {
    if (type == 'viewmore') {
      document.getElementById('exp_less' + i).style.display = 'none'
      document.getElementById('exp_more' + i).style.display = 'block'
    } else {
      document.getElementById('exp_less' + i).style.display = 'block'
      document.getElementById('exp_more' + i).style.display = 'none'
    }
  }

  deleteCandidate(candidate?) {
      const confirmRef = this.modalService.open(this.removeCandidatefromTalentpool, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      if(candidate)
        this.selectedcandidate.push(candidate.basicdetails.candidatenumber);


  }

  sortcandidatelist(sortby) {
    this.sortby = sortby
    this.getCandidateList()
  }

  getActivityText(activity): string {
    let action;
    if (activity.oldvalue == "" || activity.oldvalue == "null") {
      activity.oldvalue = null
    }
    if (activity.newvalue === '' || activity.newvalue === null || activity.newvalue === '') {
      action = 'deleted';
    } else if (activity.oldvalue === '' || activity.oldvalue === null) {
      action = 'added';
    }
    if (activity.action === 'create' || activity.action === 'add') {
      action = 'created';
    } else if (activity.action === 'remove' || activity.action === 'delete') {
      action = 'deleted';
    } else if (activity.action === 'update' || activity.action === 'updated') {
      action = 'updated';
    } else {
      action = activity.action;
    }
    ///For call Log and Notes
    if (action === 'updated' && activity.type === 'calllog') {
     return "Calllog updated"
    }
    else if (action === 'created' && activity.type === 'calllog') {
      return "Calllog craeted"
    }
    else if (action === 'updated' && activity.type === 'note') {
      return `Note updated`;
    }
    else if (action === 'created' && activity.type === 'note') {
      return `Note Created`;
    } else if (action == 'deleted' && activity.type === 'note') {
      return `Note was removed`;
    }
    ///For Experience
    else if (action === 'updated' && activity.type === 'experience' && activity.newvalue !== null) {
      return 'Experience updated'
    } else if (action === 'deleted' && activity.type === 'experience') {
      return `Experience has been removed`;
    }
    else if (action === 'created' && activity.type === 'experience') {
      return `Experience Added`;
    }
    //for Education
    else if (action === 'updated' && activity.type === 'education') {
     return `Education updated`
    }
    else if (action === 'deleted' && activity.type === 'education') {
      return `Education has been removed`;
    }
    else if (action === 'created' && activity.type === 'education') {
      return `Education Added`;
    }
    //for Basic Details
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue != null) {
      return `Profile details updated`;
    }
    else if (action == 'updated' && activity.type === 'basic details' && activity.oldvalue == null) {
      return `${activity.updatedfieldname} has been updated to ${activity.newvalue}`;
    }
    //for Skills
    else if (action == 'updated' && activity.type === 'skills') {
      return `Skills are updated`;
    } else if (action == 'created' && activity.type === 'skills') {
      return `Skills are Added`;
    }

    //for tags
    else if (action == 'updated' && activity.type === 'tags') {
      return `Tags are updated`;
    } else if (action == 'created' && activity.type === 'tags') {
      return `Tags are Added`;
    } else if (action == 'deleted' && activity.type === 'tags') {
      return `Tags are deleted`;
    }
    //for Grabbed
    else if (action == 'created' && (activity.type === 'grabbed' || activity.type == 'bulk grabbed')) {
      return `Candidate has been grabbed`;
    }
    else if (action == 'created' && activity.type === 'added') {
      return `Candidate has been Added`;
    }
    //for TalentPipeline Status
    else if (action == 'updated' && (activity.type === 'pipeline status' || activity.type === 'cron - pipeline status')) {
      return `Pipeline Status was updated`;
    }
    //for Contact Details
    else if (action == 'created' && activity.type === 'contact details - social profile') {
      return `New Social Profile Link was Added`;
    }
    else if (action == 'updated' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was updated `;
    }
    else if (action == 'deleted' && activity.type === 'contact details - social profile') {
      return `Social Profile Link was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - email') {
      return `New Email ID was Added`;
    }
    else if (action == 'updated' && activity.type === 'contact details - email') {
      return `Email ID was updated`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - email') {
      return `Email ID was removed`;
    }
    else if (action == 'created' && activity.type === 'contact details - contact number') {
      return `New Contact Number was Added`;
    }
    else if (action == 'updated' && activity.type === 'contact details - contact number') {
      return `Contact Number was updated`;
    }
    else if (action == 'deleted' && activity.type === 'contact details - contact number') {
      return `Contact Number was removed`;
    }
    else if((activity.tablename == 'candidatecontactdetail' || activity.tablename == 'candidate') && activity.type == 'Reveal Contact') {
      return  GlobalService.getAllCandidateActivityText(activity.updatedfieldname)
    }
    else if (activity.updatedfieldname == 'primaryemailid' || activity.updatedfieldname == 'primarycontactnumber') {
      return `Primary ${activity.type} has Added -  ${activity.newvalue}`;
    } else if (activity.action == 'pipl premium enrichment') {
      return 'Premium enrichment was done'
    } else if (activity.tablename) {
      if (activity.action == 'added') {
        return `Cv was added`
      } else if (activity.action == 'removed') {
        return `Cv was removed`
      }
    }
    if (activity.action == 'details updated') {
      return activity.oldvalue
    }
  }

  addtags(data) {
    const modalRef = this.modalService.open(CandidateTagsComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = data ? data.basicdetails: []
    modalRef.componentInstance.bulkcandidates = this.selectedcandidate
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'updatetags') {
        this.toastmessage("Tags updated successfully", 'success')
        this.selected = false;
        this.isCandidateSelected = true;
        this.selectedcandidate = []
        this.getCandidateList();
      } else if(x == 'error') {
        this.toastmessage("Something went Wrong", 'error')
      }
    })
  }

  openCreateCandidate(){
    // document.getElementById("mySidebar").style.display = "block";
    // document.getElementById("myOverlay").style.display = "block";
    // this.candidateSubject.next(undefined as any);
    const ref = this.modalService.open(CreateCandidateNewComponent,{ size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    ref.componentInstance.talentpoolDetails = this.talentpoolDetails;
    ref.componentInstance.passEntry.subscribe((x) => {
      this.modalService.dismissAll();
      if (x == 'candidatecreated') {
        this.toastmessage('Candidate Created Succesfully', 'success')
      }else if( x == 'duplicatecandidate'){
        this.toastmessage('Duplicate Candidate ', 'error')
      } else if(x == 'errorinsavingfile'){
        this.toastmessage('Something went wrong while saving document', 'error')
      }
      else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
      }
      this.getCandidateList();
    })

  }

  getsliderdata(event, source?: string) {
    if(event == 'refresh') {
      this.getCandidateList(null, source);
    }
  }
  // getContactDetailsFromSlider(event){
  //   console.log('event 12',event);
  //   console.log('thi.candidatedetail', this.candidatedetails);
  //   this.candidatedetails = this.candidatedetails.map((item)=>{
  //     if(item?.basicdetails?.candidatenumber === event.candidatenumber){
  //       console.log('--->asdf');
  //       item['work_email'] =event?.obj?.work_email;
  //       item['personal_email'] = event?.obj?.personal_email;
  //       item['mobile_phone'] = event?.obj?.mobile_phone;
  //     }
  //     return item;
  //   })
  //   console.log('contatdetail from sloder', this.candidatedetails);
  // }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
      else if (type == 'website'){
        link = "https://www." + link;
      }
    window.open(link, "_blank")

  }

  getCompanyInfo(data: any, type: any){
    if(data && !data.website){
      return;
    }
    // const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    // loadn[0].style.display = 'none'
    this.currentCompanyInformation = {}
    let companyData = [
      {
        ...((data?.id) && {id: data.id}),
        ...((data.companyname) && {name: data.companyname})
      }
    ];

    let website
    if(type == 'exp'){
      website = data.website
    }


    this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.data && res.data.length){
        let companyDetails = res.data[0];
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : data.companyname
        this.currentCompanyInformation['industry'] = companyDetails.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name
        this.currentCompanyInformation['size'] = companyDetails.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : website
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = companyDetails.id;
        this.currentCompanyInformation['facebook_url'] = companyDetails.facebook_url;
        this.currentCompanyInformation['twitter_url'] = companyDetails.twitter_url;
        this.currentCompanyInformation['github_url'] = companyDetails.github_url;


         // loadn[0].style.display = 'block'

      }
    });
//

  }

  checkIfObjectIsEmpty(data){
    if(data && Object.keys(data).length == 0){
      return false;
    }
    return true;
  }

  exportToPDF(candidate: any) {
    if(!(candidate && candidate.basicdetails)) return;

    this.personSearchService.exportCandidateProfileToPDF({ candidatenumber: candidate.basicdetails.candidatenumber }).subscribe((res: any) => {
      if(res) {
        if(res.status === 'failure') {
          this.errorMessage = 'Error occured while exporting to PDF';
        } else {
          const blobFile = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blobFile);
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute("href", blobUrl);
          downloadLink.setAttribute("download", `${(candidate.basicdetails.firstname || '').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())} ${(candidate.basicdetails.lastname || '').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}.pdf`);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successMessage = 'Exported to PDF successfully'
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      }
    });
  }
  //Add candidate to email campaign
  openAddToEmailCampaign(data) {
    if (data?.basicdetails?.candidatenumber) {
      this.selectedcandidate = [];
      this.selectedcandidate.push(data.basicdetails.candidatenumber);
    }
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  openAddToScreenAiModal(data) {
    if (data?.basicdetails?.candidatenumber) {
      this.selectedcandidate = [];
      this.selectedcandidate.push(data.basicdetails.candidatenumber);
    }
    const modalRef = this.modalService.open(this.addCandidateToScreenAiModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }


  getCandidateDetails(selectedCandidates: string[]): any[] {
    const candidatedetails = this.candidatedetails.map(candidate => {
      if (selectedCandidates.includes(candidate.basicdetails.candidatenumber)) {
        candidate['totalexperience'] = this.getFormattedTenure(candidate.totalexperience);
        return candidate;
      }
    }).filter(Boolean);
    return candidatedetails;
  };
  
  /**
   * Opens the AddCandidateAegisModalComponent modal and passes the selected candidates to it.
   */
  addToAegis(data: any) {

    let selectedCandidates = [];
    if (data?.basicdetails?.candidatenumber) {
      selectedCandidates.push(data.basicdetails.candidatenumber);
    } else {
      selectedCandidates = this.selectedcandidate;
    }

    const modalRef = this.modalService.open(AddCandidateAegisModalComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.candidates = this.getCandidateDetails(selectedCandidates);
    modalRef.componentInstance.calledfrom = 'talentpool';
    modalRef.componentInstance.update.subscribe((result: { status: 'success' | 'error', message: string, data: any }) => {

      if (result.status === 'success') {
        const res = result.data?.createdCandidate ? result.data.createdCandidate : result.data;
        const successCount = res?.successful || 0;
        const duplicateCount = res?.duplicate || 0;
        const failedCount = res?.unsuccessful || 0;
        const totalCount = successCount + duplicateCount + failedCount;
        if (totalCount > 0) {
          if (successCount > 0 && duplicateCount > 0 && failedCount > 0) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates, and ${failedCount} could not be added due to insufficient information.`;
          } else if (successCount && duplicateCount > 0 && !failedCount) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates.`;
          } else if (successCount && !duplicateCount && !failedCount) {
            this.successMessage = `${successCount} Candidate Tagged Successfully`;
          } else if (!successCount && duplicateCount && !failedCount) {
            this.errorMessage = `${duplicateCount} Candidate duplicate found in Aegis`;
          } else if (!successCount && !duplicateCount && failedCount) {
            this.errorMessage = `${failedCount} Candidate could not be added due to insufficient information.`;
          } else {
            this.errorMessage = `No candidates were tagged to Aegis. Please try again.`;
          }
        } else {
          this.successMessage = `No candidates were tagged to Aegis.`;
        }
      } else if (result.status === 'error') {
        const res = result.data?.createdCandidate ? result.data.createdCandidate : result.data;
        const successCount = res?.successful || 0;
        const duplicateCount = res?.duplicate || 0;
        const failedCount = res?.unsuccessful || 0;
        const totalCount = successCount + duplicateCount + failedCount;
        if (totalCount > 0) {
          if (successCount > 0 && duplicateCount > 0 && failedCount > 0) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates, and ${failedCount} could not be added due to insufficient information.`;
          } else if (successCount && duplicateCount > 0 && !failedCount) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates.`;
          } else if (successCount && !duplicateCount && !failedCount) {
            this.successMessage = `${successCount} Candidate Tagged Successfully`;
          } else if (!successCount && duplicateCount && !failedCount) {
            this.errorMessage = `${duplicateCount} Candidate duplicate found in Aegis`;
          } else if (!successCount && !duplicateCount && failedCount) {
            this.errorMessage = `${failedCount} Candidate could not be added due to insufficient information.`;
          } else {
            this.errorMessage = `No candidates were tagged to Aegis. Please try again.`;
          }
        } else {
          this.errorMessage = `Failed to tag candidates to mandate. Please try again.`;
        }
      } else if (result.status === 'unauthorized') {
        this.errorMessage = result.message;
      }
      this.selectedcandidate = [];
      this.candidatedetails.forEach((element, index) => {
        this.candidatedetails[index].selected = false;
      });
      this.selected = false;
      this.modalService.dismissAll();
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  };

  /**
   * Checks if the Aegis integration is connected by calling the Aegis integration service.
   */
  checkAegisIntegrationConnected() {
    this.aegisIntegrationService.checkAegisIntegrationConnected().subscribe((response: any) => {
      if (response && response.body && response.body?.success) {
        this.isAegisConnected = true;
      } else {
        this.isAegisConnected = false;
      }
    }, (error) => {
      if (error && error.error && error.error?.message === 'ats_integration_unauthorized') {
        this.errorMessage = 'Please connect aegis with same account';
        setTimeout(() => { this.errorMessage = ''; }, 3000);
      };
      this.isAegisConnected = false;
    });
  };


  onTypeAheadSearch(event: any): void {
    const query = event.target.value;
    this.emailCampaignService.getCampaigns({campaign_name: query,  created_by: this._localstorageservice.getItem('userdata').userid, 'status[]': [1,2], typeahead: true }).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  /** Add candidate into email campaigns in bulk */
  addToEmailCampaignV2() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();

    if (!this.campaign_input.valid || !this.selectedCampaign) {
      this.isLoadingEmailCampaignApi = false;
      return;
    }

    let unsubscribedCandidateCount = 0;
    let totalTarget = 0;
    const campaign_id = this.selectedCampaign?.campaign_id;


    let payloadArray = this.candidatedetails.map(x => {
      if (this.selectedcandidate.includes(x.basicdetails.candidatenumber)) {

        totalTarget++;

        if (x?.basicdetails?.is_unsubscribed) {
          unsubscribedCandidateCount++;
          return;
        }

        let tempFirstName = x.basicdetails?.firstname || '';
        let tempLastName = x.basicdetails?.lastname || '';

        return {
          firstname: tempFirstName,
          target_name: tempFirstName + ' ' + tempLastName,
          target_id: x.candidateid,
          target_meta: JSON.stringify({
            candidatenumber: x.basicdetails.candidatenumber,
            title: x.basicdetails.jobtitle?.length
              ? x.basicdetails.jobtitle
              : x.pastexperience?.[0],
            elastic_id: x.basicdetails?.elastic_id || null,
          }),
          target_email: null,
          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString()
        };
      }
    }).filter(Boolean);

    if (!payloadArray.length) {
      this.closeActiveModal();
      this.toastmessage("Unsubscribed from Email Campaign", 'error');
      return;
    }

    const candidateNumbers = payloadArray.map((res) => JSON.parse(res.target_meta).candidatenumber);

    this.candidateservice.getBulkCandidateContactDetails(candidateNumbers).subscribe((resp: any) => {

      if (resp?.body?.status !== 'success') {
        this.toastmessage("Error fetching contact details", "error");
        this.closeActiveModal();
        return;
      }


      const bulkData = resp.body.data || {};

      payloadArray.forEach((payload) => {

        const existingEmails = bulkData[payload?.target_id]?.emails || [];
        let personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingEmails, 'personal');
        let professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingEmails, 'professional');

        let targetEmailFound = '';

        switch (this.selectedCampaign['email_pref']) {
          case 1:
            targetEmailFound = personalPref_email;
            break;
          case 2:
            targetEmailFound = professionalPref_email;
            break;
          case 3:
            targetEmailFound = personalPref_email || professionalPref_email;
            break;
          case 4:
            targetEmailFound = professionalPref_email || personalPref_email;
            break;
        }

        payload.target_email = targetEmailFound || null;
      });

      this.emailFoundCount = payloadArray.filter(x => x.target_email).length;
      this.campaignName = this.campaign_input.value;

      this.emailCampaignService.createTarget(campaign_id, payloadArray).subscribe((res: any) => {
        this.isLoadingEmailCampaignApi = false;
            this.closeActiveModal()

        if (res.status === 'success') {
              if (res.data && res.data.length) {
              const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);

              //this.toastmessage("Candidate added to email campaign successfully", 'success');
             //
              /**
               * add email campaign
               */
              const emailCampaignParams = {
                "User ID": this._localstorageservice.getItem('userdata').userid,
                "Candidate ID": this.selectedcandidate.toString(),
                "Campaign Name": this.selectedCampaign.campaign_name
              }
              clevertap.event.push('Add Candidate to Email Campaign', emailCampaignParams);

              if (payloadArray.length !== this.emailFoundCount){
                // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                const bulkRevealPayLoad = {
                  enrichedFrom: this.enrichedFromForReveal,
                  candidates:[],
                  campaign_id: campaign_id
                }

                res.data.map((arr)=>{
                  if(!arr?.target_email){
                    bulkRevealPayLoad.candidates.push(
                      {
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  }
                });
                const modalObj = {
                  calledFor:'email-campaign',
                  total_target: totalTarget,
                  campaignDetails: this.selectedCampaign,
                  emailsFound: this.emailFoundCount,
                  payload: bulkRevealPayLoad,
                  campaign_id: campaign_id,
                  unsubscribedCandidateCount: unsubscribedCandidateCount
                }
               this.openDetailsModal(modalObj);
              }

            } else {
            this.closeActiveModal();
            if (unsubscribedCandidateCount) {
              this.toastmessage("Unsubscribed from Email Campaign", 'error');
            } else {
              this.toastmessage("Candidate already present in selected campaign", 'error');
            }
          };

          this.selectedcandidate = [];
          this.candidatedetails.forEach((element, index) => {
            this.candidatedetails[index].selected = false;
          });
          this.selected = false;
        } else {
          this.closeActiveModal();
          this.toastmessage("Candidate addition failed", "error");
        }

      }, (error: HttpErrorResponse) => {
        this.isLoadingEmailCampaignApi = false;
        if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
          const remainingTargets = error.error.remainingTargets;
          this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
        } else {
          this.toastmessage("Something went wrong", "error");
        }
        this.closeActiveModal();
      });
    }, () => {
      this.toastmessage("Something went wrong", "error");
      this.closeActiveModal();
    });

  };

  addToEmailCampaign() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if(this.campaign_input.valid && this.selectedCampaign){
      let unsubscribedCandidateCount = 0;
      let totalTarget = 0;
      const campaign_id = this.selectedCampaign?.campaign_id;
      let payloadArray = this.candidatedetails.map(x => {
        if (this.selectedcandidate.includes(x.basicdetails.candidatenumber)) {
          totalTarget++;
          if(x?.basicdetails?.is_unsubscribed){
            unsubscribedCandidateCount++;
            return;
          }
          let tempFirstName = (x.basicdetails?.firstname) ? x.basicdetails.firstname : '';
          let tempLastName = (x.basicdetails?.lastname) ? x.basicdetails.lastname : '';
          return {
            firstname: tempFirstName,
            target_name: tempFirstName + ' ' + tempLastName,
            target_id: x.candidateid,
            target_meta: JSON.stringify({
              "candidatenumber": x.basicdetails.candidatenumber,
              "title": x.basicdetails.jobtitle && x.basicdetails.jobtitle.length ? x.basicdetails.jobtitle : x.pastexperience[0],
              "elastic_id": (x.basicdetails?.elastic_id) ? x.basicdetails.elastic_id : null,
            }),
            target_email:null,
            is_active: true,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString()
          };
        }
      }).filter(Boolean);
      payloadArray = payloadArray.filter(x => x);

      Promise.all(payloadArray.map(async (x) => {
        // Wait for the async operation to complete
        x.target_email = await this.getAllContactDetails(JSON.parse(x.target_meta).candidatenumber, this.selectedCampaign['email_pref']);
        // Return the updated payload object to the Promise.all() call
        return x;
      })).then((updatedPayloadArray) => {

        //count total target emails in uploadPayloadArray store it in this.emailFoundCount

        this.emailFoundCount = 0;
        updatedPayloadArray.forEach(element => {
          if (element.target_email) {
            this.emailFoundCount++;
          }
        }
        );

        if(unsubscribedCandidateCount > 0 && updatedPayloadArray.length === 0){
          this.closeActiveModal();
          this.toastmessage("Unsubscribed from Email Campaign", 'error');
          return;
        }
        this.campaignName = this.campaign_input.value;

        this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
          if (res.status == 'success') {
            this.closeActiveModal()
            this.isLoadingEmailCampaignApi = false;
            if (res.data && res.data.length) {
              const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);

              //this.toastmessage("Candidate added to email campaign successfully", 'success');
             //
              /**
               * add email campaign
               */
              const emailCampaignParams = {
                "User ID": this._localstorageservice.getItem('userdata').userid,
                "Candidate ID": this.selectedcandidate.toString(),
                "Campaign Name": this.selectedCampaign.campaign_name
              }
              clevertap.event.push('Add Candidate to Email Campaign', emailCampaignParams);

              if (updatedPayloadArray.length !== this.emailFoundCount){
                // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                const bulkRevealPayLoad = {
                  enrichedFrom: this.enrichedFromForReveal,
                  candidates:[],
                  campaign_id: campaign_id
                }

                res.data.map((arr)=>{
                  if(!arr?.target_email){
                    bulkRevealPayLoad.candidates.push(
                      {
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  }
                });
                const modalObj = {
                  calledFor:'email-campaign',
                  total_target: totalTarget,
                  campaignDetails: this.selectedCampaign,
                  emailsFound: this.emailFoundCount,
                  payload: bulkRevealPayLoad,
                  campaign_id: campaign_id,
                  unsubscribedCandidateCount: unsubscribedCandidateCount
                }
               this.openDetailsModal(modalObj);
              }

            }
            else {
              this.closeActiveModal();
              if(unsubscribedCandidateCount){
                this.toastmessage("Unsubscribed from Email Campaign", 'error');
              }
              else this.toastmessage("Candidate already present in selected campaign", 'error');
            }

              this.selectedcandidate = [];
              this.candidatedetails.forEach((element, index) => {
              this.candidatedetails[index].selected = false;
              this.selectedcandidate = []
              this.selectedcandidateForNote = []
            })
            this.selected = false;
          }

          //show toast message if candidate addition failed
           else if(res.status=='failure') {
            this.closeActiveModal()
            this.toastmessage("candidate addition failed", "error");
          }
        }, (error: HttpErrorResponse) => {
              this.isLoadingEmailCampaignApi = false;
              if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                const remainingTargets = error.error.remainingTargets;
                this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
              } else {
                this.toastmessage("Something went wrong", "error");
              }
              this.closeActiveModal();
            });
      }).catch((error) => {
        this.toastmessage("An error occurred during candidate addition", "error");
        this.closeActiveModal()

      });
    }
    else{
      this.isLoadingEmailCampaignApi = false;
    }

  }

  getAllScreenAIJobs() {
    // Trigger valueChanges by emitting the current value
    if (!this.job_input.value) {
      this.job_input.setValue('', { emitEvent: true });
    }
  }

  /**
   * Check if a job is currently being screened.
   */
  isScreeningInProgress(job: any){
    return job.batch_status === 'pending';
  }

  /**
   * Get tooltip text for a job.
   */
  getTooltipText(job: any){
    if(job.batch_status === 'pending'){
      return 'Screening in progress, please try after sometime';
    }
    return '';
  }

  // Add this function to handle the selection from the typeahead
  onJobSelected(value): void {
    this.selectedJob = value;
    this.job_input.setValue(value.name);
  }

  /**
   * Typeahead search handler for job input in ScreenAI modal
   */
  searchJob(event: any): void {
    const query = (event.target.value || '').trim();
    this.atsResumeScreenService.getAllScreenAIJobsBySource(query, 'create').subscribe((res: any) => {
      if (res.status === 'success') {
        this.jobList = query
          ? (res.data || []).filter((j: any) => j.name && j.name.toLowerCase().includes(query.toLowerCase()))
          : (res.data || []);
      }
    });
  }

  /**
   * Redirect to ScreenAI page for the selected job
   */
  redirectToScreenAi(): void {
    if (this.selectedJob && this.selectedJob.ats_job_id) {
      this.router.navigate([`/resume-screen/candidate-listing/${this.selectedJob.ats_job_id}`]);
    } else {
      this.router.navigate(['/resume-screen']);
    }
    this.closeActiveModal();
  }

  /**
   * Add selected candidates to a ScreenAI job.
   * Performs a duplicate check first (per candidate), then calls the add API.
   */
  addToScreenAi(): void {
    this.job_input.markAllAsTouched();
    if (!this.job_input.valid || !this.selectedJob) {
      return;
    }

    this.isLoadingScreenAiApi = true;

    // Build the list of candidates we are attempting to add
    const candidatesForAdd = this.candidatedetails.filter(x =>
      this.selectedcandidate.includes(x.basicdetails.candidatenumber)
    );

    if (!candidatesForAdd.length) {
      this.isLoadingScreenAiApi = false;
      this.screenAiDuplicateCheckDone = true;
      this.addCandidateSuccess = false;
      this.postAddMssg = 'No candidates selected.';
      return;
    }
    // Build bulk payload for all candidates at once
    const candidatesForDupCheck = candidatesForAdd.map(candidate => {
      return {
        ...candidate.basicdetails,
        elastic_id: candidate.basicdetails.source === "Talent Discovery" ? candidate.basicdetails.elastic_id : candidate.basicdetails.candidatenumber
      }
    });
    const bulkDupPayload = {
      candidateDetails: candidatesForDupCheck,
      jobnumber: this.selectedJob.jobnumber
    }

    this.atsResumeScreenService.checkDuplicateCandidate(bulkDupPayload).toPromise()
      .then((res: any) => {
        const duplicateIds = new Set(res?.duplicateIds || []);
        const results = candidatesForAdd.map((candidate) => {
          const lookupId = candidate.basicdetails.source === "Talent Discovery"
            ? candidate.basicdetails.elastic_id
            : candidate.basicdetails.candidatenumber;

          return {
            candidate,
            isDuplicate: duplicateIds.has(lookupId)
          };
        });

        const duplicates = results.filter(r => r.isDuplicate);
        const nonDuplicates = results.filter(r => !r.isDuplicate);

        if (duplicates.length > 0 && nonDuplicates.length === 0) {
          // All are duplicates — do not proceed
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.postAddMssg = `${duplicates.length === 1 ? 'This candidate is' : `${duplicates.length} candidates are`} already present in this ScreenAI job. No new candidates will be added.`;
          return;
        }
        // Build payload for non-duplicates only
        const candidateinfo = nonDuplicates.map(r => ({
          elasticid: r.candidate.basicdetails.source === "Talent Discovery"
            ? r.candidate.basicdetails.elastic_id
            : r.candidate.basicdetails.candidatenumber,
          source: r.candidate.basicdetails.source || 'Talent Discovery',
          talentpoolcandidateactivity: r.candidate.talentpoolMappingDetails
        }));

        const addPayload = {
          jobnumber: this.selectedJob.jobnumber,
          candidateinfo,
          calledfrom: "talentpool"
        };

        this.atsResumeScreenService.addCandidatesToScreenAI(addPayload).subscribe((res: any) => {
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;

          if (res && res.status === 'success') {
            this.addCandidateSuccess = true;
            const addedCount = candidateinfo.length;
            const skippedCount = duplicates.length;
            if (skippedCount > 0) {
              this.postAddMssg = `${addedCount} candidate${addedCount !== 1 ? 's' : ''} added to ScreenAI successfully. ${skippedCount} candidate${skippedCount !== 1 ? 's were' : ' was'} already present and skipped.`;
            } else {
              this.postAddMssg = `${addedCount} candidate${addedCount !== 1 ? 's' : ''} added to ScreenAI successfully.`;
            }
          } else {
            this.addCandidateSuccess = false;
            this.postAddMssg = (res && res.message) ? res.message : 'Something went wrong while adding to ScreenAI. Please try again.';
          }
        }, () => {
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.selectedcandidate = [];
          this.selectedJob = null;
          this.postAddMssg = 'Something went wrong while adding to ScreenAI. Please try again.';
        });
      })
      .catch(() => {
        this.isLoadingScreenAiApi = false;
        this.screenAiDuplicateCheckDone = true;
        this.addCandidateSuccess = false;
        this.selectedcandidate = [];
        this.selectedJob = null;
        this.postAddMssg = 'Something went wrong during duplicate check. Please try again.';
      });
  }
  getAllContactDetails(candidateid, emailPref) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };

      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let personalPref_email = '';
            let professionalPref_email = '';
            let targetEmailFound = '';
            const existingContactDetails = res?.data?.emails;
            if (existingContactDetails && existingContactDetails.length) {

              personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal')
              professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional')

              switch (emailPref) {
                case 1: targetEmailFound = personalPref_email;
                  break;
                case 2: targetEmailFound = professionalPref_email;
                  break;
                case 3: targetEmailFound = personalPref_email ? personalPref_email : professionalPref_email;
                  break;
                case 4: targetEmailFound = professionalPref_email ? professionalPref_email : personalPref_email;
                  break;
              }
            }

            if (targetEmailFound) {
              resolve(targetEmailFound);
            } else {
              // reject("email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }

  /**
   * Function used to open Modal and to create Bulk Reveal payload
   */
  bulkRevealTalentpool(type) {
    const modalObj = {
      calledFor:'talentpool',
      total_target: this.candidatesWithoutContactNumber,
      campaignDetails: this.selectedCampaign,
      emailsFound:  0,
      payload: this.bulkRevealPayload(),
      campaign_id: null,
      unsubscribedCandidateCount: 0
    }
    this.bulkRevealType = "Bulk CTA";
    this.openDetailsModal(modalObj);
  }

  /**
   * Function will return payload for bulk reveal and calculate the number of candidates without personsal email or contact number
   */
  bulkRevealPayload(){
    const bulkRevealPayLoad = {
      enrichedFrom: this.enrichedFromForReveal,
      talentpoolnumber: this.talentpoolnumber,
      candidates: []
    }
    this.selectedCandidateData = [];
    this.candidatesWithoutContactNumber = 0;
    this.candidatesWithoutContactInfo = 0;
    this.candidatedetails.map(x => {
      if (this.selectedcandidate.includes(x.basicdetails.candidatenumber)) {
        this.selectedCandidateData.push(x);
        if(!(x?.mobile_phone?.length) || !(x?.work_email?.length) || !(x?.personal_email?.length) ){
          this.candidatesWithoutContactInfo++;
          bulkRevealPayLoad.candidates.push({
            elastic_id: x.basicdetails?.elastic_id,
            talentpoolcandidatemappingid: x?.talentpoolMappingDetails?.talentpoolcandidatemappingid
          })
        }
        if(!x?.mobile_phone?.length){this.candidatesWithoutContactNumber++;}
      }
    });
    return bulkRevealPayLoad;
  }


  /**
   * Fuction used to know that, bulk reveal is still in process,
   * If yes then will show banner
   */
  bulkRevealBannerStatus(data = null) {
    this.talentpoolnumber &&
      this.talentpoolservice.bulkRevealStatus({ talentpoolnumber: this.talentpoolnumber }).subscribe((result: any) => {
        this.isBulkRevealInProcess = true;
        if(data){
          this.candidatedetails.map(x => {
            if (data.includes(x?.basicdetails?.elastic_id)) {
              x.talentpoolMappingDetails['bulkcontactrevealstatus'] = 1;
            }
          })
        }

      }, (err) => {
        this.isBulkRevealInProcess = false
      })
    this.fetchCurrentCredits();
  }

  fetchCurrentCredits() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const creditsData = this.transactionservice.credits();
    if (creditsData) {
      let userData = this._localstorageservice.getItem('userdata')
      userData['balancebasiccontactenrichmentcredits'] = creditsData.balancebasiccontactenrichmentcredits
      this._localstorageservice.setItem('userdata', userData)
      this.transactionservice.createPaymentData();
    }
  }

  /**
   * Remove Bulk Reveal banner
   */
  removeBulkProcessDiv(){
    const ele = document.getElementById("bulk-process");
    if(ele) ele.style.display = 'none';
    const ele2 = document.getElementById("bulk-talentpool-level");
    if(ele2) ele2.style.display = 'none';
  }

  openDetailsModal({ campaign_id, payload, emailsFound, total_target, calledFor, unsubscribedCandidateCount = 0, onTalentpoolLevel =  false }) {
    this.closeActiveModal();
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = calledFor;
    modalRef.componentInstance.talentpoolSelectedCandidate = {data: this.selectedCandidateData, onTalentpoolLevel: onTalentpoolLevel};
    modalRef.componentInstance.unsubscribedCandidateCount = unsubscribedCandidateCount;
    modalRef.componentInstance.bulkRevealType = this.bulkRevealType;

    modalRef.componentInstance.bulkRevealModalData.subscribe((res) => {
      if (res.status === 'success') {
        if (res?.data && res?.data?.candidates?.length) {
          this.bulkRevealBannerStatus(res.data.candidates);
        }
        this.bulkRevealBannerTalentpoolLevel.showBanner = false;
      }
      else if(res.status === 'failure'){
        this.toastmessage("Something went wrong", 'error');
      }
    });
  }
  closeActiveModal(){
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.bulkDownloadCSVSelectedOption = null; // reset bulk download csv selection
    // Reset ScreenAI modal state
    this.screenAiDuplicateCheckDone = false;
    this.isLoadingScreenAiApi = false;
    this.postAddMssg = '';
    this.addCandidateSuccess = false;
    this.selectedJob = null;
    this.job_input.markAsUntouched();
    this.job_input.markAsPristine();
    this.job_input.reset();
    this.jobList = []
    this.modalService.dismissAll();
  }

  getEmailPref(data){
    if(data==1){
      return 'personal';
    }
    else if(data==2){
      return 'professional';
    }
    else if(data==3){
      return 'FirstPersonal';
    }
    else{
      return 'FirstProfessional';
    }
  }

  /**
   * Tab change handler
   * @param tabName
   */

  onTabChange(tabName: 'talentpoolCandidates' | 'similarCandidates') {
    switch (tabName) {
      case 'talentpoolCandidates':
        this.router.navigate(['../'], { relativeTo: this.route, queryParamsHandling: 'merge' });
        this.currentPage = 1;
        this.isprofile = true;
        this.isSimilarCandidatesTabActive = false;
        break;
      case 'similarCandidates':
        this.router.navigate(['suggestions'], { relativeTo: this.route, queryParamsHandling: 'merge' });
        this.currentPage = 1;
        this.isprofile = false;
        this.isSimilarCandidatesTabActive = true;
        break;
      default:
        this.currentPage = 1;
        this.isprofile = true;
        this.isSimilarCandidatesTabActive = false;
        break;
    }

    this.setPage(1);
  }

  /**
   * Fetch suggested candidates count
   */
  getTalentpoolSuggestedCandidatesCount() {
    if(!this.talentpooldetails?.talentpoolnumber) return;

    if(this.talentpooldetails?.candidatecount < 10) {
      this.talentpooldetails.suggestedCandidatesCount = 0;
      return;
    }

    this.talentpoolservice.getTalentpoolSuggestedCandidateCount(this.talentpooldetails.talentpoolnumber).subscribe((res) => {
      if(res.status === 'success') {
        this.talentpooldetails.suggestedCandidatesCount = res.data.totalResultsCount;
      }
    }, (err) => {
      console.log("[TalentpoolDetailsComponent] getTalentpoolSuggestedCandidatesCount() error - ", err);
      this.talentpooldetails.suggestedCandidatesCount = 0;
    })
  }

  /**
   * Method to refresh only the candidates count after adding candidates from the suggestions
   */
  refreshTalentpoolCandidateCount() {
    const data = {
      startingfrom: this.start,
      resultsize: this.profilesPerPage ? this.profilesPerPage : 10,
      usernumber: this._localstorageservice.getItem('usernumber'),
      ...this.appliedFilters,
      sortby: this.sortBy || 'new'
    }

    if (this.talent_option == 'all') {
      data['pipelinestatus'] = "'Hot', 'Warm', 'Cold'"
    } else {
      data['pipelinestatus'] = "'" + this.talent_option + "'"
    }

    if(this.talentpooldetails && this.talentpooldetails.talentpoolnumber){
      data['talentpoolnumber'] = this.talentpooldetails.talentpoolnumber
    }
    if(this.sortby) {
      data['sortby'] = this.sortby
    }

    this.candidateservice.getCandidateList(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.totalcandidatecount = res.data.candidatedetails.length;
        this._localstorageservice.setItem('talentPoolDetails', res.data);
        this.candidateTotalCount = res.data.candidatenumbers.length
        this.talentpoolservice.setAllCandidateDetails(res?.data || null);
        this.talenpoolrefreshEvent.emit('refresh')
        this.candidateEvent.emit(this.candidateTotalCount)
        this.totalBulkCandidatesNumber = res.data.candidatenumbers
      }
    })
  }

  /**
   * Add selected candidates from recommendations to the current talentpool
   * @param payload
   */
  moveRecommendedCandidatesToTalentpool(payload: { talentpoolNumber?: string, candidate?: any[] } = {}) {
    const { talentpoolNumber, candidate } = payload;

    // pre-processing
    const talentpoolNumberForAction = talentpoolNumber || this.talentpooldetails?.talentpoolnumber;
    const candidateElasticIds = candidate ? candidate.map(c => c.idinindex).filter(Boolean) : this.selectedSimilarCandidates.map(c => c.idinindex).filter(Boolean);

    // basic validations
    if(!(talentpoolNumberForAction && candidateElasticIds && candidateElasticIds.length)) return;
    if(talentpoolNumberForAction !== this.talentpooldetails?.talentpoolnumber) return;

    const migrationPayload = {
      talentpoolname: this.talentpooldetails?.talentpoolname,
      talentpoolnumber: this.talentpooldetails?.talentpoolnumber,
      elasticid: candidateElasticIds,
      source: 'talentpool-recommendations'
    }
    this.isLoadingForSimilarCandidates = true;
    this.personSearchService.addToTanentpool(migrationPayload).subscribe((result: any) => {
      if (result.status == 'success') {
        this.selected = false;
        this.similarCandidatesEventEmitter.next({ action: 'BULK_SELECTION', data: { value: false } });

        const len = candidateElasticIds.length || 0;
        if (len === 1) {
          this.successMessage = `Candidate moved to talentpool successfully`;
        } else if (result?.isPartial) {
          this.successMessage = `${result.newCandidateCount} candidates have successfully been added to this talentpool. There were ${result.duplicateCount} candidates which were already part of this talentpool.`;
        } else {
          this.successMessage = `${len} candidates have successfully been added to this talentpool.`;
        }

        this.selectedSimilarCandidates = [];
        this.refreshTalentpoolCandidateCount(); // to refresh candidate count
        this.similarCandidatesEventEmitter.next({ action: 'ALERT', data: { type: 'SUCCESS', candidates: candidateElasticIds } })
         /**
           * Add to talentpool
           */
          const talentpoolParams = {
            "User ID": this._localstorageservice.getItem('userdata').userid,
            "Candidate ID": candidateElasticIds.toString(),
            "Talentpool Name": this.talentpooldetails?.talentpoolname
          }
          clevertap.event.push('Add Candidate to Talentpool', talentpoolParams);

      } else if (result.status == 'failure') {
        if (result.message == 'User not on paid plan') {
          this.modalService.dismissAll()
          this.modalService.open(this.premiumUserError, { windowClass: "modalExtract", centered: true })
        } else {
          this.errorMessage = 'Something went Wrong';
        }
        this.similarCandidatesEventEmitter.next({ action: 'ALERT', data: { type: 'FAILURE', candidates: candidateElasticIds } })
      }

      this.isLoadingForSimilarCandidates = false;

      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    })
  }

  /**
   * Handler for events emitted from talentpool suggestions component
   * @param event
   */
  handleTalentpoolSuggestionEvents(event: { action: string, data: { type?: string, talentpoolNumber?: string, candidate?: any[] } }) {
    if(!(event && event.data)) return;

    const talentpoolNumberForAction = event.data.talentpoolNumber;
    if(talentpoolNumberForAction !== this.talentpooldetails?.talentpoolnumber) return;

    switch(event.action) {
      case 'ADD_TO_TALENTPOOL':
        this.moveRecommendedCandidatesToTalentpool({ talentpoolNumber: talentpoolNumberForAction, candidate: event.data.candidate });
        break;

      case 'PAGINATION_RESET':
        this.setPage(1);
        break;

      case 'STATE_UPDATE':
        if(event.data && event.data.type === 'CANDIDATE_SELECTED') {
          this.selectedSimilarCandidates = event.data.candidate;
        }
        break;

      case 'REFRESH':
        this.getCandidateList();
        break;
    }
  }

/**
 * Select mode to create candidate
 * @param event
 */
  selectedCandidateCreatMode(event: any) {

    switch (event) {

      case 'create-candidate': {
        this.openCreateCandidate();
        break;
      };
      case 'upload-cv': {
        this.openUploadBulkResemeORCsvModel('resume');
        break;
      };
      case 'csv': {
        this.openUploadBulkResemeORCsvModel('csv');
        break;
      };
      default: {
        break;
      };
    }
  }

  /**
   * Open model model either selected mode upload resume or CSV
   * @param type
   * @returns
   */
  openUploadBulkResemeORCsvModel(type: string) {
    if (type == 'resume') {
      const modalRef = this.modalService.open(BulkResumeUploadModelComponent, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false })
      modalRef.componentInstance.id = this.talentpoolnumber ? this.talentpoolnumber : null;
      modalRef.componentInstance.event.subscribe((res: any) => {
        if (res.status == 'success') {
          this.getCandidateList();
          this.successMessage = 'Candidate Created successfully!';
          setTimeout(() => { this.successMessage = ''; }, 3000);
          this.dismiss();
        } else if (res.status == 'cancel') {
          this.dismiss();
        } else {
          this.errorMessage = 'Something went wrong, Please try agian!';
          setTimeout(() => { this.errorMessage = ''; }, 3000);
          this.dismiss();
        }
      })
    } else if (type == 'csv') {
       const modalRef = this.modalService.open(CsvFileUploadModelComponent, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.id = this.talentpoolnumber ? this.talentpoolnumber : null;
        modalRef.componentInstance.event.subscribe((res: any) => {
        if (res.status == 'success') {
          this.getCandidateList();
          this.successMessage = 'Candidate Created successfully!';
          setTimeout(() => { this.successMessage = ''; }, 3000);
          this.dismiss();
        } else if (res.status == 'failed' && res.message == 'WRONG_CSV_FORMAT') {
          this.errorMessage = 'Missing or incorrect required columns. Refer sample file.';
          setTimeout(() => { this.errorMessage = ''; }, 3000);
          this.dismiss();
        } else if (res.status == 'failed' && res.message == 'FILE_SIZE_EXEED') {
          this.errorMessage = 'File size limit exeeded';
          setTimeout(() => { this.errorMessage = ''; }, 3000);
          this.dismiss();
        } else if (res.status == 'cancel') {
          this.dismiss();
        } else {
          this.errorMessage = 'Something went wrong, Please try agian!';
          setTimeout(() => { this.errorMessage = ''; }, 3000);
          this.dismiss();
        }
      })
    } else {
      return;
    };

  };


  dismiss() {
    this.modalService.dismissAll();
    this.createCandidateMode = 'select';
  }

  showActivity(data) {
    return data?.candidatetagscount > 0 || data?.candidatenotecount > 0
      || data?.candidatefilecount > 0 || data?.talentpoolcount > 0
      || data?.emailcampaigncount || data?.iswebbtreeverified || data?.unifieddropped || data?.lastcandidateactivity.length || data?.usedWebbtreeIntroduction
  }

  getRevealStatus(data){
    if(data && data.status == 'reveal-contact-clicked') {
      this.candidatedetails = this.candidatedetails.map((item)=>{
        if(item?.basicdetails?.candidatenumber === data?.data?.candidatenumber){
          item.contactRevealStatus = 'reveal-contact-clicked';
        } else {
          item.contactRevealStatus = null;
        }
        return item;
      });
    }
    console.log('data for reveal status in candidate listing', data);
  }

  redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
  }
}
